























































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import AMSDialog from '@/components/AMSDialog.vue';
import { emptyRule, pwdRule, equalRule, regRule, specialCharRule, rangeRule } from '@/utils/rules';
import { UserStore } from '@/store/modules/user';
import { modifyPhone, modifyPWD, modifyName } from '@/api/user';
import { sendVerificationCode } from '@/api/system';
import { AppStore } from '@/store/modules/app';

@Component({
  components: {
    'ams-dialog': AMSDialog
  }
})
export default class PersonaCener extends Vue {
  showOldPwd: boolean = false;
  showNewPwd: boolean = false;
  showReNewPwd: boolean = false;
  /**旧密码 */
  oldPwd: string = '';
  /**新密码 */
  newPwd: string = '';
  /**确认密码 */
  reNewPwd: string = '';
  /**手机号码 */
  defaultPhone: string = '';
  phone: string = '';
  /**验证码 */
  code: string = '';
  /**姓名 */
  name: string = '';
  /**数据权限 */
  dataPermission: string = '';
  /**关联角色 */
  role: string = '';

  /**弹窗配置 */
  dialogWidth: number = 500;
  showDialog: boolean = false;

  /**true为显示编辑手机号码 false显示修改密码 */
  isModifyPhoneDialog: boolean = false;
  /**是否是退成登录倒计时 */
  isCountDown: boolean = false;
  /**是否是已经获取验证码 */
  // isGetCode: boolean = false;

  /**验证码倒计时 */
  count: number = 0;
  timer: any = null;

  get disabled() {
    return this.count > 0 || !this.phone;
  }

  get userInfo() {
    return UserStore.userInfo;
  }

  /**弹框标题 */
  get dialogTitle() {
    if (this.isCountDown) return '提示';
    return this.isModifyPhoneDialog ? '修改手机号码' : '修改密码';
  }

  /**原密码验证规则 */
  get pwdRules() {
    const rules = [];
    if (this.oldPwd) {
      rules.push(pwdRule);
    } else {
      rules.push(emptyRule('密码'));
    }
    return rules;
  }

  /**新密码验证规则 */
  get newPwdRules() {
    const rules = [];
    if (this.newPwd) {
      rules.push(pwdRule);
    } else {
      rules.push(emptyRule('新密码'));
    }
    if (this.newPwd && this.reNewPwd) {
      rules.push(equalRule(this.newPwd, this.reNewPwd, '两次输入的密码不一致'));
    }
    return rules;
  }

  /**确认密码验证规则 */
  get rePwdRules() {
    const rules = [];
    if (this.reNewPwd) {
      rules.push(pwdRule);
    } else {
      rules.push(emptyRule('确认新密码'));
    }
    if (this.newPwd && this.reNewPwd) {
      rules.push(equalRule(this.newPwd, this.reNewPwd, '两次输入的密码不一致'));
    }
    return rules;
  }

  /**手机号码验证 */
  get phoneRules() {
    const rules = [];
    if (this.phone) {
      rules.push(regRule(/^1[3-9][0-9]{9}$/, '手机号格式错误'));
    } else {
      rules.push(emptyRule('手机号'));
    }

    return rules;
  }

  /**验证码验证 */
  get codeRules() {
    const rules = [];
    if (this.code) {
      rules.push((v: any) => {
        if (this.code.length != 4) {
          return '请输入有效的四位验证码';
        } else {
          return true;
        }
      });
    } else {
      rules.push(emptyRule('验证码'));
    }
    return rules;
  }

  /**姓名验证 */
  get nameRules() {
    const rules = [];
    rules.push(emptyRule('姓名'));
    rules.push(specialCharRule(this.name));
    return rules;
  }

  /**显示修改手机号码弹窗 */
  showModifyPhoneDialog() {
    const _this = this;
    UserStore.GetUserInfo().then((response: any) => {
      this.phone = this.defaultPhone;
      this.isModifyPhoneDialog = true;
      this.isCountDown = false;
      this.showDialog = true;
    });
  }
  /**显示修改密码弹窗 */
  showModifyPWDDialog() {
    this.isModifyPhoneDialog = false;
    this.isCountDown = false;
    this.showDialog = true;
  }

  /**获取验证码 */
  getCode() {
    if (this.phone != undefined && this.phone != '') {
      sendVerificationCode(this.phone).then((response: any) => {
        // this.isGetCode = true;
        AppStore.ShowSuccess('发送验证码成功');
        this.showCodeCountDown();
      });
    }
  }

  /**显示验证码倒计时 */
  showCodeCountDown() {
    const TIME_COUNT = 60;
    if (!this.timer) {
      this.count = TIME_COUNT;
      let _this = this;
      this.timer = setInterval(() => {
        if (_this.count > 0 && _this.count <= TIME_COUNT) {
          this.count--;
        } else {
          // this.isGetCode = false;
          clearInterval(_this.timer);
          _this.timer = null;
        }
      }, 1000);
    }
  }

  /**提交修改 */
  submitModify() {
    this.showDialog = false;
  }

  /**点击了取消 */
  close() {
    this.showDialog = false;
    this.$nextTick(() => {
      (this.$refs.modifyPhoneForm as any).resetValidation();
      (this.$refs.modifyPwdForm as any).resetValidation();
      this.reset();
    });
  }

  reset() {
    this.code = '';
    this.oldPwd = '';
    this.reNewPwd = '';
    this.newPwd = '';
  }

  /**显示倒计时 */
  showLoginCountDown() {
    this.isCountDown = true;
    const TIME_COUNT = 3;

    this.count = TIME_COUNT;
    let _this = this;
    this.timer = setInterval(() => {
      if (_this.count > 0 && _this.count <= TIME_COUNT) {
        this.count--;
      } else {
        clearInterval(_this.timer);
        _this.timer = null;
        _this.showDialog = false;
        UserStore.FedLogOut();
        _this.$router.replace('/login');
      }
    }, 1000);
  }

  /**原密码输入事件 */
  onOldPwdInput() {
    this.$nextTick(() => {
      (this.$refs.modifyPwdForm as any).validate();
    });
  }

  /**新密码输入事件 */
  onNewPwdInput() {
    this.$nextTick(() => {
      (this.$refs.modifyPwdForm as any).validate();
    });
  }

  /**确认密码输入事件 */
  onReNewPwdInput() {
    this.$nextTick(() => {
      (this.$refs.modifyPwdForm as any).validate();
    });
  }

  /**点击了底部返回 */
  onBack() {
    if (window.history.length <= 1) {
      this.$router.push('/');
    } else {
      this.$router.go(-2);
    }
  }

  /**点击了底部保存 */
  onSave() {
    if ((this.$refs.infoForm as any).validate()) {
      modifyName(this.name).then((response: any) => {
        AppStore.ShowSuccess('修改姓名成功');
        UserStore.GetUserInfo();
      });
    }
  }

  /**点击了提交按钮 */
  submit() {
    //修改手机号
    if (this.isModifyPhoneDialog) {
      // if (this.isGetCode) {
      if ((this.$refs.modifyPhoneForm as any).validate()) {
        modifyPhone(this.phone, this.code).then((response: any) => {
          // this.isGetCode = false;
          this.reset();
          AppStore.ShowSuccess('修改手机号成功');
          this.showLoginCountDown();
        });
      }
      // } else {
      //   AppStore.ShowError('请获取验证码');
      // }
    }
    //修改密码
    else {
      if ((this.$refs.modifyPwdForm as any).validate()) {
        modifyPWD(this.oldPwd, this.newPwd).then((response: any) => {
          this.reset();
          AppStore.ShowSuccess('修改密码成功');
          this.showLoginCountDown();
        });
      }
    }
    // this.showDialog = false;
  }
  getPermissionName(status: string) {
    switch (status) {
      case 'All':
        return '全部客户';
      case 'Self':
        return '本人关联客户';
    }
  }
  @Watch('userInfo', { immediate: true, deep: true })
  onMenuVisibleChange(newValue: any, oldValue: any) {
    this.defaultPhone = newValue.phone;
    this.name = newValue.name;
    this.dataPermission = this.getPermissionName(newValue.dataPermission) + '';
    this.role = newValue.roleName;
  }
}
